import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Text from '@/components/Text';
import { RootState } from '@/utils/store';

export const TeamHeading: FC<PropsWithChildren> = ({ children }) => {
  const { teamId } = useParams();

  const teamName = useSelector(
    (state: RootState) => state.teams[teamId || '']?.name,
  );

  if (!teamName) return null;

  return (
    <Text $type="caption" $color="gray">
      {children ? children : teamName}
    </Text>
  );
};

export const UserRoleHeading: FC<PropsWithChildren> = ({ children }) => {
  const userRole = useSelector(
    (rootState: RootState) => rootState.auth.user!.role.name,
  );

  if (!userRole) return null;

  return (
    <Text $type="caption" $color="gray" $isUpperCase>
      {children ? children : userRole}
    </Text>
  );
};

export const PageHeading = styled(Text).attrs({
  $type: 'heading1',
  as: 'h1',
})`
  margin: 6px 0 32px;
`;

export const HeadingsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionHeading = styled(Text).attrs({
  as: 'h3',
  $type: 'smallBold',
  $color: 'gray',
})`
  margin: 0 0 12px;
  text-transform: uppercase;
`;

export const Sections = styled.div<{ $gapY?: number }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: ${({ $gapY = 32 }) => $gapY}px;
`;

export const SrOnly = styled.span`
  clip: rect(0, 0, 0, 0);
  border-width: 0;
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  left: -10px;
  top: auto;
`;
